/**
 * Width of the left-hand tab rail on the steps that have one. Not a
 * `panelWidths` token: those size side panels and overlay drawers, and this is
 * an in-body tab list.
 */
export const TAB_RAIL_WIDTH = 240;
